import {} from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * SiteExportViewModel starts a tenant records download on command.
 * Inject `save` so the ViewModel never touches the DOM.
 */
export class SiteExportViewModel extends ViewModel {
    client;
    save;
    constructor(client, save) {
        super({ loading: false, error: null, lastFilename: null });
        this.client = client;
        this.save = save;
    }
    async download() {
        await this.run(async () => {
            const out = await this.client.downloadSiteExport();
            this.save(out);
            this.setState({ lastFilename: out.filename });
        }, "We could not prepare your export. Please try again.");
    }
}
//# sourceMappingURL=SiteExportViewModel.js.map